export default __webpack_public_path__ + "static/media/43.548dcb06.png";